/*
 * PhotoHouse preview – framed image gallery white-screen recovery.
 * No Shopify cart, product option or inventory writes.
 * Uses only the exact product.media sources already embedded in the native
 * V7 thumbnail rail; never invents a frame image or fabricates a variant.
 */
(function(){
  'use strict';
  function items(root,selector){return Array.prototype.slice.call(root.querySelectorAll(selector));}
  function finish(value){
    var s=String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    if(/black|שחור/.test(s))return 'black';
    if(/wenge|wenga|וונגה|ונגה/.test(s))return 'wenge';
    if(/amber|ענבר/.test(s))return 'amber';
    if(/printing only|print only|no frame|unframed|without frame|ללא מסגרת|הדפסה בלבד/.test(s))return 'print';
    return '';
  }
  function mount(article){
    if(article.dataset.phQaGalleryRecovery==='1')return;
    var gallery=article.querySelector('.ctm_product_gallery_main');
    var native=gallery&&gallery.querySelector('.filter_product_gallery');
    var rail=article.querySelector('[data-ph-v7-rail]');
    var frameHolder=items(article,'.product__variant-holder').find(function(node){
      var label=node.querySelector('label');
      var select=node.querySelector('select.product__variant');
      return select&&label&&/frame|מסגר/i.test(label.textContent||'');
    });
    var selector=frameHolder&&frameHolder.querySelector('select.product__variant');
    if(!gallery||!native||!rail||!selector)return;
    var thumbs=items(rail,'[data-ph-v7-thumb][data-ph-v7-full]');
    if(thumbs.length<2)return;
    article.dataset.phQaGalleryRecovery='1';
    var stage=document.createElement('div');
    stage.className='ph-qa__gallery-recovery';
    stage.hidden=true;
    stage.setAttribute('aria-hidden','true');
    var image=document.createElement('img');
    image.alt='';
    image.decoding='async';
    stage.appendChild(image);
    gallery.appendChild(stage);
    var generation=0, readyUrl='', pendingUrl='', raf=0;

    function exactMedia(){
      var selectedKind=finish(selector.value);
      var selected=thumbs.find(function(t){
        var alt=(t.querySelector('img')||{}).alt||'';
        return finish(alt)===selectedKind;
      });
      if(!selected && thumbs.length===1)selected=thumbs[0];
      return selected?selected.getAttribute('data-ph-v7-full'):'';
    }
    // V11 uses separate, validated image stages for framed prints and gifts.
    // The last-resort recovery overlay must NEVER compete with a stage that
    // is already showing the selected Shopify media. This is deliberately
    // a read-only check: neither stage nor native Flickity is modified.
    function selectedStageVisible(){
      var states=[
        ['ph-preview-has-selected-media','[data-ph-selected-frame-media-stage]'],
        ['ph-gift-media-active','[data-ph-gift-media-stage]']
      ];
      return states.some(function(pair){
        if(!article.classList.contains(pair[0]))return false;
        var el=gallery.querySelector(pair[1]);
        return Boolean(el && !el.hidden);
      });
    }
    function nativeVisible(){
      if(article.classList.contains('ph-auto-frame-active'))return true;
      var media=items(native,'.product-gallery__item:not(.remove-from-flick)');
      if(!media.length)return false;
      var current=media.filter(function(x){return x.classList.contains('is-selected');});
      if(!current.length)current=media;
      return current.some(function(cell){
        var img=cell.querySelector('.lazy-image > img');
        if(!img||!img.complete||img.naturalWidth<100||img.naturalHeight<100)return false;
        var box=img.getBoundingClientRect();
        if(box.width<40||box.height<40)return false;
        var style=window.getComputedStyle(cell);
        return style.display!=='none'&&style.visibility!=='hidden'&&Number(style.opacity)!==0;
      });
    }
    function evaluate(){
      raf=0;
      if(article.classList.contains('ph-auto-frame-active')||selectedStageVisible()||nativeVisible()){
        stage.hidden=true;
        return;
      }
      var wanted=exactMedia();
      if(!wanted){stage.hidden=true;return;}
      if(readyUrl===wanted&&image.complete&&image.naturalWidth>100){
        stage.hidden=false;
        return;
      }
      if(pendingUrl===wanted)return;
      var token=++generation;
      pendingUrl=wanted;
      var preload=new Image();
      preload.onload=function(){
        if(token!==generation||!article.isConnected)return;
        pendingUrl='';
        if(preload.naturalWidth<100){stage.hidden=true;return;}
        readyUrl=wanted;
        image.src=wanted;
        if(!article.classList.contains('ph-auto-frame-active')&&!selectedStageVisible()&&!nativeVisible())
          stage.hidden=false;
      };
      preload.onerror=function(){
        if(token!==generation)return;
        pendingUrl='';
        stage.hidden=true; // no unverified/wrong-variant fallback
      };
      preload.src=wanted;
    }
    function queue(){
      if(raf)return;
      raf=window.requestAnimationFrame(evaluate);
    }
    function changed(){
      ++generation;
      pendingUrl='';
      stage.hidden=true;
      queue();
      window.setTimeout(queue,160);
      window.setTimeout(queue,450);
      window.setTimeout(queue,1000);
    }
    selector.addEventListener('change',changed);
    if(window.jQuery&&window.jQuery.fn)window.jQuery(selector).on('change.phQaGallery',changed);
    new MutationObserver(queue).observe(native,{
      subtree:true,childList:true,attributes:true,
      attributeFilter:['class','style','src','srcset']
    });
    native.addEventListener('load',queue,true);
    window.addEventListener('resize',queue,{passive:true});
    queue();
  }
  function begin(){
    if(!document.body||!document.body.classList.contains('ph-v1')||
       !document.body.classList.contains('template-product')||
       document.body.classList.contains('template-product-portfolio'))return;
    items(document,'article.product.page-section').forEach(mount);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',begin);
  else begin();
  document.addEventListener('shopify:section:load',begin);
}());
